import { Plus, Delete, CirclePlus } from '@element-plus/icons-vue'
// import * as ElementPlusIcons from '@element-plus/icons-vue'
import type { App } from 'vue'
//https://github.com/element-plus/element-plus/issues/7293
import 'element-plus/es/components/dialog/style/css'

export default (app: App<Element>) => {
    // const ElementPlusIcons = [Plus]
    // 全局注册ElementPlus图标
    // for (const [key, component] of Object.entries(ElementPlusIcons)) {
    //     console.log(key, component)
    //     app.component(key, component)
    // }
    app.component('Plus', Plus)
    app.component('Delete', Delete)
    app.component('CirclePlus', CirclePlus)
}
